
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2336|7609|8789)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
